/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import Header from "./header"
import Footer from "./Footer"
import "./layout.css"

const Layout = ({ children, description, lang, meta }) => {
  const date = new Date()
  const year = date.getFullYear()

  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            keywords
            author
          }
        }
        allContentfulLink(sort: { fields: [createdAt], order: ASC }) {
          edges {
            node {
              title
              url
            }
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title
  return (
    <>
      <Helmet
        htmlAttributes={{
          lang,
        }}
        title={defaultTitle}
        meta={[
          {
            name: `description`,
            content: metaDescription,
          },
          {
            property: `og:title`,
            content: defaultTitle,
          },
          {
            name: "keywords",
            content: site.siteMetadata.keywords,
          },
          {
            property: `og:description`,
            content: metaDescription,
          },
          {
            property: `og:type`,
            content: `website`,
          },
          {
            name: `twitter:card`,
            content: `summary`,
          },
          {
            name: `twitter:creator`,
            content: site.siteMetadata?.author || ``,
          },
          {
            name: `twitter:title`,
            content: defaultTitle,
          },
          {
            name: `twitter:description`,
            content: metaDescription,
          },
        ].concat(meta)}
      />
      <Header />
      <main>{children}</main>
      <Footer>
        Cualquier consulta envíanos un email a{" "}
        <span href="..." style={{ color: "#1890ff", fontWeight: 600 }}>
          stptransparencia@gmail.com
        </span>{" "}
        ©{year}
      </Footer>
    </>
  )
}

Layout.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
}

export default Layout
